import { toast } from "react-toastify";

/**
 * Извлекает человекочитаемое сообщение из ошибки RTK Query / unified-envelope
 * бэкенда EyeHub и показывает toast.
 *
 * Формат ошибки бэкенда: `{data: null, error: {message?, detail?, code, details:[{message,target}]}}`.
 * `axiosBaseQuery` кладёт тело ответа в `err.data`, HTTP-код — в `err.status`.
 * Раньше страницы показывали статичный текст, из-за чего причина отказа (403,
 * валидация полей, конфликт) не доходила до оператора.
 *
 * @param {unknown} err        ошибка из `await mutation().unwrap()`
 * @param {string}  fallback   текст, если сервер не прислал сообщение
 * @returns {string} показанное сообщение (удобно для тестов)
 */
export function extractApiError(err, fallback = "Не удалось выполнить действие") {
  if (!err) return fallback;

  const body = err.data ?? err;
  const apiError = body?.error ?? body;

  // Полевые ошибки валидации: показываем первую с указанием поля.
  const details = apiError?.details;
  if (Array.isArray(details) && details.length) {
    const first = details[0];
    const target = first?.target && first.target !== "non_field_errors" ? `${first.target}: ` : "";
    if (first?.message) return `${target}${first.message}`;
  }

  const msg = apiError?.message || apiError?.detail || apiError?.title;
  if (typeof msg === "string" && msg.trim()) return msg;

  if (err.status === 403) return "Недостаточно прав для этого действия";
  if (err.status === 404) return "Объект не найден";
  if (typeof err.status === "number" && err.status >= 500) {
    return "Ошибка сервера, попробуйте позже";
  }
  return fallback;
}

/**
 * Показывает toast с сообщением бэкенда.
 * @param {unknown} err
 * @param {string} fallback
 * @returns {string} показанный текст
 */
export function toastApiError(err, fallback) {
  const message = extractApiError(err, fallback);
  toast.error(message);
  return message;
}

export default toastApiError;
